/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LiveState } from './LiveState';
import {
    LiveStateFromJSON,
    LiveStateFromJSONTyped,
    LiveStateToJSON,
    LiveStateToJSONTyped,
} from './LiveState';

/**
 * 
 * @export
 * @interface PresenceOverride
 */
export interface PresenceOverride {
    /**
     * 
     * @type {LiveState}
     * @memberof PresenceOverride
     */
    state: LiveState;
    /**
     * Epoch ms. REQUIRED — no permanent overrides.
     * @type {number}
     * @memberof PresenceOverride
     */
    expiresAt: number;
    /**
     * Free-text audit trail.
     * @type {string}
     * @memberof PresenceOverride
     */
    reason: string;
    /**
     * Admin user who set the override.
     * @type {string}
     * @memberof PresenceOverride
     */
    actorUserId: string;
    /**
     * 
     * @type {number}
     * @memberof PresenceOverride
     */
    createdAt: number;
}



/**
 * Check if a given object implements the PresenceOverride interface.
 */
export function instanceOfPresenceOverride(value: object): value is PresenceOverride {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('actorUserId' in value) || value['actorUserId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function PresenceOverrideFromJSON(json: any): PresenceOverride {
    return PresenceOverrideFromJSONTyped(json, false);
}

export function PresenceOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresenceOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'state': LiveStateFromJSON(json['state']),
        'expiresAt': json['expiresAt'],
        'reason': json['reason'],
        'actorUserId': json['actorUserId'],
        'createdAt': json['createdAt'],
    };
}

export function PresenceOverrideToJSON(json: any): PresenceOverride {
    return PresenceOverrideToJSONTyped(json, false);
}

export function PresenceOverrideToJSONTyped(value?: PresenceOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': LiveStateToJSON(value['state']),
        'expiresAt': value['expiresAt'],
        'reason': value['reason'],
        'actorUserId': value['actorUserId'],
        'createdAt': value['createdAt'],
    };
}

